<template>
  <div id="app">
    <!-- <keep-alive>
      <router-view :style="{ height: stageHeight + 'px' }" />
    </keep-alive> -->
    <keep-alive>
      <router-view
        v-if="$route.meta.keepAlive"
        :style="{ height: stageHeight + 'px' }"
      />
    </keep-alive>
    <router-view
      v-if="!$route.meta.keepAlive"
      :style="{ height: stageHeight + 'px' }"
    />
  </div>
</template>
<script>
import { BASE_STAGE_HEIGHT } from '@/store/mutation-types.js';

export default {
  name: 'app',

  components: {},

  data() {
    return {
      stageHeight: '',
      heightChange: 0,
    };
  },

  computed: {},

  created() {
    if (this.$bsUtils.getUrlParams('marginTop') !== '1') {
      this.setScreenHeight();
      window.addEventListener('resize', this.setScreenHeight);
      this.saveStore();
    } else {
      // this.stageHeight = document.body.clientHeight;
    }
  },

  mounted() {
    this.saveStore();
  },

  beforeDestory() {
    window.removeEventListener('resize', this.setScreenHeight);
    if (this.$bsUtils.getClientType() == 'ios') {
      window.removeEventListener('pagehide', this.setStorage);
    } else {
      window.removeEventListener('beforeunload', this.setStorage);
    }
  },

  methods: {
    setScreenHeight() {
      let fullScreenOffset = 0;
      // 页面可见区域高度
      let screenHeight = document.body.clientHeight;
      // 是否iPhone全面屏
      // if (this.$bsUtils.isIphoneFullScreen()) {
      //   // 苹果全面屏页面安全高度
      //   fullScreenOffset = 94;
      //   // 获取整个屏幕高度
      //   screenHeight = window.screen.height;
      // }
      // 页面高度
      this.heightChange = this.stageHeight - screenHeight;
      this.$store.commit(
        `base/${BASE_STAGE_HEIGHT}`,
        screenHeight - fullScreenOffset
      );
      this.stageHeight = this.$store.state.base.stageHeight;
      this.scrollInView();
    },
    scrollInView() {
      let activeEle = document.activeElement;
      if (
        activeEle &&
        (activeEle.tagName == 'INPUT' || activeEle.tagName == 'TEXTAREA')
      ) {
        let clientRect = activeEle.getBoundingClientRect();
        if (clientRect.bottom > document.body.clientHeight) {
          let scrollBox = document.getElementsByClassName('bs-wrapper')[0];
          if (!scrollBox) return;
          let h = scrollBox.scrollTop + this.heightChange;
          setTimeout(() => {
            scrollBox.scrollTop = h;
          });
        }
      }
    },
    saveStore() {
      localStorage.getItem('store') &&
        this.$store.replaceState(
          Object.assign(
            this.$store.state,
            JSON.parse(localStorage.getItem('store'))
          )
        );

      //在页面刷新时将vuex里的信息保存到localStorage里
      // if (this.$bsUtils.getClientType() == 'ios') {
      //   window.addEventListener('pagehide', this.setStorage);
      // } else {
      //   window.addEventListener('beforeunload', this.setStorage);
      // }
      window.addEventListener('pagehide', this.setStorage);
      window.addEventListener('beforeunload', this.setStorage);
    },
    setStorage() {
      localStorage.setItem('store', JSON.stringify(this.$store.state));
    },
  },
};
</script>
<style lang="less">
@import '~@/assets/less/common.less';
@import '~@/assets/less/global.less';
.clickBlock {
  position: absolute;
  border: 1px solid red;
  //background-color: red;
}
</style>
